import CustomerDeliveryFileUpdate from '@components/file-update/customer-delivery-files';

const CustomerDeliveryFileUpdatePage = () => {
  return <CustomerDeliveryFileUpdate />;
};

export default CustomerDeliveryFileUpdatePage;
